<template>
  <FormItem :name="name">
    <select v-model="model">
      <option
        v-for="(item, index) in options"
        :key="index"
        :value="item"
        :selected="selected === item"
      >
        {{ displayOptions[index] }}
      </option>
    </select>
  </FormItem>
</template>

<script setup lang="ts">
import FormItem from './Form-item.vue'

const props = defineProps({
  name: { type: String, required: true },
  // placeholder: { type: String},
  options: { type: Array<any> }, //this should just be plain string arrays
  displayOptions: { type: Array<String> }
})

const model = defineModel<any>('selected')
</script>
